import { Injectable } from '@angular/core';
import { Route, PreloadingStrategy } from '@angular/router';
import { Observable } from 'rxjs/Rx';
@Injectable()
export class AppPreLoadingStrategy implements PreloadingStrategy {

  preload(route: Route, load: Function): Observable<any> {
    //console.log('AppPreLoadingStrategy', route, load);
    if (route.data && route.data['preload']) {
     // console.log('AppPreLoadingStrategy', route, load);
      return load();
    }
    return Observable.of(null);
  }

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/app.preloadstrategy.ts